const CarLoad = () =>
  import(
    /* webpackChunkName: "base-info-car-load" */ '@/pages/base-info/car/load/index.vue'
  )
const CreateCarLoad = () =>
  import(
    /* webpackChunkName: "base-info-car-load" */ '@/pages/base-info/car/load/create.vue'
  )
const EditCarLoad = () =>
  import(
    /* webpackChunkName: "base-info-car-load" */ '@/pages/base-info/car/load/edit.vue'
  )

export default {
  path: 'load',
  meta: {
    label: 'carLoad',
    auth: 'load'
  },
  component: {
    name: 'Load',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCarLoad',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CarLoad
    },
    {
      name: 'BaseInfoCreateCarLoad',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCarLoad
    },
    {
      name: 'BaseInfoEditCarLoad',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCarLoad,
      props: true
    }
  ]
}
